import { Box, Divider, Grid } from '@material-ui/core';
import React from 'react';
import { Title } from '../Procedure.styled';
import { SubTitle } from './RetractorUsed.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { sizes } from 'src/styles/Media.styled';
import InputBox from 'src/common/refactoredComponents/input/Input';
import { useTranslation } from 'react-i18next';
import {
    FONT_FAMILY_REGULAR,
    BLACK_FONT_COLOR,
    SEMANTIC_TEXT_PX,
    BASE_TEXT_PX
} from 'src/styles/fonts/MCFontConstants';

const RetractorUsedCard = ({
    retractorUsedData,
    checkboxSelectionChangeHandler,
    handleInputChange,
    retractorUsedOtherFieldValue,
    textAreaCharLimit,
    charCountLimit,
}) => { 
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.smalDevice;
    const isTabletView =
        winWidth >= sizes.smalDevice && winWidth <= sizes.ipadAir;
    const lastRetractorUsedData =
        retractorUsedData[retractorUsedData.length - 1];
    const { t } = useTranslation();
    const retractorUsedTitle = t('orders.index.retractor');
    return (
        <Box
            my={1}
            bgcolor={'#ffffff'}
            boxShadow={'0px 0px 6px #00000029'}
            borderRadius={5}
            // padding={'16px 22px'}
            width={'99.66%'}
            position={'relative'}
            border={
                retractorUsedData.filter((item) => item.isSelected).length > 0
                    ? '1px solid #12C8F7'
                    : ''
            }
            marginLeft={'1px'}
            marginRight={'1px'}
        >
            <Title
                paddingTop={'16px'}
                paddingRight={'22px'}
                paddingLeft={'22px'}
                mbpaddingTop={'16px'}
                mbpaddingRight={'22px'}
                mbpaddingLeft={'22px'}
                fontSize={BASE_TEXT_PX}
            >
                <span>{retractorUsedTitle}</span>
                <span className="asterisk">*</span>
            </Title>
            <SubTitle padding={'0 22px 5px 22px'}>
                {t(
                    'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.physicianFinder.pleaseCheckMsg'
                )}
            </SubTitle>
            <Grid container style={{ paddingBottom: '60px' }}>
                {isMobileView && (
                    <Grid item xs={12} style={{ paddingBottom: '12px' }}>
                        <Divider />
                    </Grid>
                )}
                {isMobileView ? (
                    retractorUsedData &&
                    retractorUsedData.map((obj, idx) => (
                        <Grid
                            item
                            xs={12}
                            key={obj.code}
                            style={{
                                height:
                                    obj !== lastRetractorUsedData
                                        ? '50px'
                                        : '65px',
                            }}
                        >
                            <Checkbox
                                id={obj.description + idx}
                                checked={obj.isSelected}
                                label={obj.description}
                                margin={'3px 0 0 22px'}
                                labelStyleObj={{
                                    fontFamily: FONT_FAMILY_REGULAR,
                                    textAlign: 'left',
                                    fontSize: SEMANTIC_TEXT_PX,
                                    letterSpacing: '-0.12px',
                                    color: BLACK_FONT_COLOR,
                                    opacity: 1,
                                    paddingLeft: '17px',
                                }}
                                onCheckboxSelectionChange={(e) =>
                                    checkboxSelectionChangeHandler(
                                        e,
                                        'retractorsUsed',
                                        idx,
                                        obj.description
                                    )
                                }
                            />
                            {isMobileView && (
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        paddingBottom: '12px',
                                        paddingTop: '12px',
                                    }}
                                >
                                    {/* {obj!==lastRetractorUsedData &&
                                    <Divider />} */}
                                    <Divider />
                                </Grid>
                            )}
                            {obj.description === 'Other' && (
                                <>
                                    <InputBox
                                        id={`reportUsage-${obj.description}`}
                                        placeholder={t(
                                            'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.physicianFinder.placeHolder'
                                        )}
                                        style={{
                                            margin:
                                                winWidth <= sizes.mobileDevice
                                                    ? '-10px 0px 0px 20px'
                                                    : '12px 0px 0px 58px',
                                            width:
                                                winWidth <= sizes.mobileDevice
                                                    ? '90%'
                                                    : '85%'
                                        }}
                                        maxLength={textAreaCharLimit}
                                        value={retractorUsedOtherFieldValue}
                                        onChange={(e) =>
                                            obj.isSelected
                                                ? handleInputChange(
                                                      'retractorUsedOtherFieldValue',
                                                      e.target.value
                                                  )
                                                : null
                                        }
                                        disabled={!obj.isSelected}
                                    />
                                    <SubTitle
                                        // padding={'0 22px 5px 10px'}
                                        margin={
                                            isMobileView && '5px 22px 10px 65px'
                                        }
                                        justifyContent={'flex-end'}
                                    >
                                        {`${
                                            charCountLimit -
                                                retractorUsedOtherFieldValue?.length <
                                            0
                                                ? 0
                                                : charCountLimit -
                                                  retractorUsedOtherFieldValue?.length
                                        } ${t('equity.surgery.remainchar')}`}
                                    </SubTitle>
                                </>
                            )}
                        </Grid>
                    ))
                ) : (
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            {retractorUsedData.slice(0, 8).map((obj, idx) => (
                                <Grid
                                    item
                                    xs={12}
                                    key={obj.code}
                                    style={{ height: '50px' }}
                                >
                                    <Checkbox
                                        id={obj.description + idx}
                                        checked={obj.isSelected}
                                        label={obj.description}
                                        margin={'3px 0 0 22px'}
                                        labelStyleObj={{
                                            fontFamily: FONT_FAMILY_REGULAR,
                                            textAlign: 'left',
                                            fontSize: BASE_TEXT_PX,
                                            letterSpacing: '-0.12px',
                                            color: BLACK_FONT_COLOR,
                                            opacity: 1,
                                            paddingLeft: '17px',
                                        }}
                                        onCheckboxSelectionChange={(e) =>
                                            checkboxSelectionChangeHandler(
                                                e,
                                                'retractorsUsed',
                                                idx,
                                                obj.description
                                            )
                                        }
                                    />
                                    {obj.description === 'Other' && (
                                        <>
                                            <InputBox
                                                placeholder={t(
                                                    'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.physicianFinder.placeHolder'
                                                )}
                                                style={{
                                                    margin:
                                                        winWidth <=
                                                        sizes.mobileDevice
                                                            ? '-10px 0px 0px 48px'
                                                            : '12px 0px 0px 58px',
                                                    width:
                                                        winWidth <=
                                                        sizes.mobileDevice
                                                            ? '70%'
                                                            : '80%',
                                                }}
                                                maxLength={textAreaCharLimit}
                                                value={
                                                    retractorUsedOtherFieldValue
                                                }
                                                onChange={(e) =>
                                                    obj.isSelected
                                                        ? handleInputChange(
                                                              'retractorUsedOtherFieldValue',
                                                              e.target.value
                                                          )
                                                        : null
                                                }
                                                disabled={!obj.isSelected}
                                            />
                                            <SubTitle
                                                margin={
                                                    isTabletView
                                                        ? '5px 20px 10px 65px'
                                                        : '5px 48px 10px 65px'
                                                }
                                                justifyContent={'flex-end'}
                                            >
                                                {`${
                                                    charCountLimit -
                                                        retractorUsedOtherFieldValue?.length <
                                                    0
                                                        ? 0
                                                        : charCountLimit -
                                                          retractorUsedOtherFieldValue?.length
                                                } ${t(
                                                    'equity.surgery.remainchar'
                                                )}`}
                                            </SubTitle>
                                        </>
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                        <Grid item xs={6}>
                            {retractorUsedData.slice(8, 16).map((obj, idx) => (
                                <Grid
                                    item
                                    xs={12}
                                    key={obj.code}
                                    style={{ height: '50px' }}
                                >
                                    <Checkbox
                                        id={obj.description}
                                        checked={obj.isSelected}
                                        label={obj.description}
                                        margin={'3px 0 0 22px'}
                                        labelStyleObj={{
                                            fontFamily: FONT_FAMILY_REGULAR,
                                            textAlign: 'left',
                                            fontSize: SEMANTIC_TEXT_PX,
                                            letterSpacing: '-0.12px',
                                            color: BLACK_FONT_COLOR,
                                            opacity: 1,
                                            paddingLeft: '17px',
                                        }}
                                        onCheckboxSelectionChange={(e) =>
                                            checkboxSelectionChangeHandler(
                                                e,
                                                'retractorsUsed',
                                                idx + 8,
                                                obj.description
                                            )
                                        }
                                    />
                                    {obj.description === 'Other' && (
                                        <>
                                            <InputBox
                                                placeholder={t(
                                                    'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.physicianFinder.placeHolder'
                                                )}
                                                style={{
                                                    margin:
                                                        winWidth <=
                                                        sizes.mobileDevice
                                                            ? '-10px 0px 0px 48px'
                                                            : '12px 0px 0px 58px',
                                                    width:
                                                        winWidth <=
                                                        sizes.mobileDevice
                                                            ? '70%'
                                                            : '80%',
                                                }}
                                                maxLength={textAreaCharLimit}
                                                value={
                                                    retractorUsedOtherFieldValue
                                                }
                                                onChange={(e) =>
                                                    obj.isSelected
                                                        ? handleInputChange(
                                                              'retractorUsedOtherFieldValue',
                                                              e.target.value
                                                          )
                                                        : null
                                                }
                                                disabled={!obj.isSelected}
                                            />
                                            <SubTitle
                                                margin={
                                                    isTabletView
                                                        ? '5px 20px 10px 65px'
                                                        : '5px 48px 10px 65px'
                                                }
                                                justifyContent={'flex-end'}
                                            >
                                                {`${
                                                    charCountLimit -
                                                        retractorUsedOtherFieldValue?.length <
                                                    0
                                                        ? 0
                                                        : charCountLimit -
                                                          retractorUsedOtherFieldValue?.length
                                                } ${t(
                                                    'equity.surgery.remainchar'
                                                )}`}
                                            </SubTitle>
                                        </>
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default RetractorUsedCard;
